module.exports = __webpack_public_path__ + "static/media/ethereum.86b356aa.png";